import { ref } from 'vue'

export type ToastType = 'success' | 'error' | 'warning' | 'info'

export interface Toast {
  id: number
  message: string
  type: ToastType
  timeout?: number
}

// Use a global state for toasts
const toasts = ref<Toast[]>([])
let toastId = 0

export function useToast() {
  const showToast = (message: string, type: ToastType = 'info', timeout: number = 5000) => {
    const id = ++toastId


    toasts.value.push({
      id,
      message,
      type,
      timeout
    })

    return id
  }

  const removeToast = (id: number) => {
    const index = toasts.value.findIndex((toast) => toast.id === id)
    if (index !== -1) {
      toasts.value.splice(index, 1)
    }
  }


  const showSuccess = (message: string, timeout?: number) => showToast(message, 'success', timeout)

  const showError = (message: string, timeout?: number) => showToast(message, 'error', timeout)

  const showWarning = (message: string, timeout?: number) => showToast(message, 'warning', timeout)

  const showInfo = (message: string, timeout?: number) => showToast(message, 'info', timeout)


  const clearAllToasts = () => {
    toasts.value = []
  }


  const toastCount = () => toasts.value.length

  return {
    toasts,
    showToast,
    removeToast,
    showSuccess,
    showError,
    showWarning,
    showInfo,
    clearAllToasts,
    toastCount
  }
}
